import React from 'react'

import { Button, Modal, Form, Col, Row } from '_zari/core'

import { Code128 } from 'utils'

const CodigoBarrasModal = ({ handleClose, show, codigo, descripcion, items }) => {
  const modoLote = Array.isArray(items) && items.length > 0
  const listaItems = modoLote ? items : [{ codigo, descripcion }]

  const [cantidad, setCantidad] = React.useState(1)
  const [anchoBarra, setAnchoBarra] = React.useState(2)
  const [altoBarras, setAltoBarras] = React.useState(60)
  const [mostrarTexto, setMostrarTexto] = React.useState(true)

  const previewSvg = React.useMemo(() => {
    const first = listaItems[0]
    if (!first || !first.codigo) return ''
    try {
      return Code128.buildSvg(first.codigo, {
        barWidth: Number(anchoBarra) || 2,
        height: Number(altoBarras) || 60,
        displayText: mostrarTexto
      })
    } catch (err) {
      return `<div style="color:red">Error: ${err.message}</div>`
    }
  }, [listaItems, anchoBarra, altoBarras, mostrarTexto])

  const imprimir = React.useCallback(() => {
    const n = Number(cantidad) || 1
    const labels = []
    for (const it of listaItems) {
      if (!it.codigo) continue
      let svg
      try {
        svg = Code128.buildSvg(it.codigo, {
          barWidth: Number(anchoBarra) || 2,
          height: Number(altoBarras) || 60,
          displayText: mostrarTexto
        })
      } catch (err) {
        continue
      }
      for (let i = 0; i < n; i++) {
        labels.push(`<div class="barcode-label">${svg}<div class="barcode-descripcion">${it.descripcion || ''}</div></div>`)
      }
    }

    const html = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Códigos de Barras</title>
          <style>
            body { margin: 0; font-family: Arial, sans-serif; }
            .barcode-label {
              display: inline-block;
              margin: 4mm;
              padding: 2mm;
              border: 1px dashed #ccc;
              text-align: center;
              page-break-inside: avoid;
            }
            .barcode-descripcion {
              font-size: 10px;
              margin-top: 2mm;
              max-width: 50mm;
              word-wrap: break-word;
            }
            @media print {
              .barcode-label { border: none; }
            }
          </style>
        </head>
        <body>
          ${labels.join('')}
          <script>
            window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); };
          </script>
        </body>
      </html>
    `

    const win = window.open('', '_blank')
    if (win) {
      win.document.write(html)
      win.document.close()
    }
  }, [listaItems, cantidad, anchoBarra, altoBarras, mostrarTexto])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>
          CÓDIGO DE BARRAS
          {modoLote ? ` (LOTE - ${listaItems.length} activos)` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!modoLote && (
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label text='CÓDIGO' md={12} />
                <Col md={12}>
                  <Form.InputText disabled defaultValue={codigo} />
                </Col>
              </Form.Group>
            </Col>
            <Col md={8}>
              <Form.Group>
                <Form.Label text='DESCRIPCIÓN' md={12} />
                <Col md={12}>
                  <Form.InputText disabled defaultValue={descripcion} />
                </Col>
              </Form.Group>
            </Col>
          </Row>
        )}
        {modoLote && (
          <Row>
            <Col md={12}>
              <div style={{ padding: '8px', background: '#fffae6', border: '1px solid #f0d25a', marginBottom: '8px' }}>
                Se imprimirán {listaItems.length} activos × {Number(cantidad) || 1} copias ={' '}
                <strong>{listaItems.length * (Number(cantidad) || 1)} etiquetas</strong>
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={3}>
            <Form.Group>
              <Form.Label text={modoLote ? 'COPIAS x ACTIVO' : 'CANTIDAD'} md={12} />
              <Col md={12}>
                <Form.InputText type='number' value={cantidad} onChange={e => setCantidad(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='ANCHO BARRA' md={12} />
              <Col md={12}>
                <Form.InputText type='number' value={anchoBarra} onChange={e => setAnchoBarra(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='ALTO' md={12} />
              <Col md={12}>
                <Form.InputText type='number' value={altoBarras} onChange={e => setAltoBarras(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='MOSTRAR TEXTO' md={12} />
              <Col md={12} style={{ paddingTop: '8px' }}>
                <input type='checkbox' checked={mostrarTexto} onChange={e => setMostrarTexto(e.target.checked)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ textAlign: 'center', padding: '20px', background: '#f7f7f7', minHeight: '120px' }}>
            <div dangerouslySetInnerHTML={{ __html: previewSvg }} />
            {modoLote && <div style={{ marginTop: '8px', fontSize: '11px', color: '#888' }}>Previsualización del primer activo</div>}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='primary' onClick={imprimir}>
          Imprimir
        </Button>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(CodigoBarrasModal)
